import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
export const Logout = (props) => {
  const history = useHistory();
  const logout = () => {
    const userID = localStorage.getItem("UserID");
    console.log("Logout", userID);
    console.log("loadbook");
    axios({
      method: "GET",
      headers: { "Content-Type": "application/json" },
      url: `${process.env.REACT_APP_BASE_URL}mfb/rest/authentication/logout_user?user_id=${userID}`,
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    })
      .then((res) => {
        if (res.status == 200) {
          console.log(res);
          localStorage.removeItem("UserID");
          localStorage.removeItem("isAdmin");
          history.push("/Login");
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  return (
    <div className="cursor-pointer" onClick={logout}>
      Logout
    </div>
  );
};
